module.exports = __webpack_public_path__ + "static/room2-b5c47f29c7a0150b3dc5b5183604575a.jpg";